import { loadingSpinner } from "../helpers";

class ProductCard extends HTMLElement {
  constructor(options) {
    super();

    this.options = Object.assign(
      {
        selectors: {
          variantSelector: ".product-card__selector input",
          selectedVariant: "select#js-selected-variant",
          optionSelectors: ".product-card__selector",
          primaryImage: ".primary-image",
          secondaryImage: ".secondary-image",
        },
        texts: {
          soldOut: "Sold out",
        },
      },
      options
    );

    this.s = this.options.selectors;
    this.t = this.options.texts;

    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", this.onSubmitHandler);
    }

    this.init();
  }

  init() {
    this.initSelect();
    this.linkedProductHover();
    this.attachButtonListeners();
  }

  initSelect() {
    this.querySelectorAll(this.s.variantSelector).forEach((el) => {
      el.addEventListener("change", (e) => {
        var values = [];
        var variant = "";
        var value = this.getOptionValues(values);
        var variant_selector = this.querySelector(this.s.selectedVariant);

        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            variant = value[i];
          } else {
            variant = variant + " / " + value[i];
          }
        }

        this.changeVariant(variant, variant_selector);
        this.fetchVariantImage(variant_selector);
      });
    });
  }

  getOptionValues(values) {
    var optionSelectors = this.querySelectorAll(this.s.optionSelectors);

    optionSelectors.forEach(function (selector, index) {
      if (index == 0) {
        let option = selector.querySelector("input:checked");
        values.push(option.value);
      } else {
        let options = selector.querySelectorAll("input");
        options.forEach(function (option, index) {
          if (!option.hasAttribute("checked")) return;

          values.push(option.value);
        });
      }
    });

    return values;
  }

  changeVariant(variant, variant_selector) {
    variant_selector.querySelectorAll("option").forEach(function (option) {
      var text = option.innerText.trim();
      if (text.indexOf(variant) === -1) return;

      let value = option.value;
      if (typeof value != "undefined") {
        variant_selector.value = value;
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        variant_selector.dispatchEvent(evt);
      }
    });
  }

  fetchVariantImage(variant) {
    let handle = variant.dataset.productHandle;

    window
      .fetch(window.Shopify.routes.root + `products/${handle}.js`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.json())
      .then((r) => {
        //
        this.changeVariantImage(r, variant);
        this.changeAddToCartCTA(r, variant);
      })
      .catch((error) => {
        //
        console.log(error);
      });
  }

  changeVariantImage(r, variant) {
    let id = parseInt(variant.value);
    let selectedVariant = r.variants.find((obj) => obj.id === id);

    if (selectedVariant.featured_image == null) return;

    let variantImage = selectedVariant.featured_image.src;
    let primaryImage = this.querySelector(this.s.primaryImage);
    let secondaryImage = this.querySelector(this.s.secondaryImage);

    primaryImage.srcset = variantImage;
    if (secondaryImage != null) {
      secondaryImage.srcset = variantImage;
    }
  }

  changeAddToCartCTA(r, variant) {
    let id = parseInt(variant.value);
    let selectedVariant = r.variants.find((obj) => obj.id === id);

    if (!selectedVariant.available) {
      let addToCart = this.querySelector(".product-card__button");
      addToCart.value = this.t.soldOut;
      addToCart.classList.add("disabled");
      addToCart.disabled = true;
    } else {
      let addToCart = this.querySelector(".product-card__button");
      addToCart.value = "Add to cart";
      addToCart.classList.remove("disabled");
      addToCart.disabled = false;
    }
  }

  // onSubmitHandler(event) {
  //   event.preventDefault();
  //   const submitButton = this.querySelector('[type="submit"]');
  //   loadingSpinner(submitButton);
  // }

  attachButtonListeners() {
    this.querySelectorAll('[type="submit"]').forEach((button) => {
      button.addEventListener("click", (event) => {
        loadingSpinner(event.currentTarget); // Apply spinner to the clicked button only
      });
    });
  }

  linkedProductHover() {
    document.querySelectorAll('.product-card').forEach(productCard => {
      const imageContainer = productCard.querySelector('.linked-product__image');
      const priceContainer = productCard.querySelector('.js-product-price');
      const originalPrice = priceContainer.innerHTML; // Store the original price

      productCard.querySelectorAll('.js-product-colour-swatch').forEach(swatch => {
        swatch.addEventListener('mouseover', function() {
          imageContainer.classList.add('fade-out'); // Start fade-out effect
          priceContainer.classList.add('fade-out');

          setTimeout(() => {
            imageContainer.innerHTML = `
              <div class="aspect-3/4 bg-product-card-bg fade">
                <img class="w-full h-full object-cover" src="${this.getAttribute('data-large')}">
              </div>`;
            imageContainer.classList.remove('fade-out'); // Remove fade-out
            imageContainer.classList.add('fade-in'); // Apply fade-in effect
            priceContainer.innerHTML = `
              <span class="fade">${this.getAttribute('data-price')}</span>
            `;
            priceContainer.classList.remove('fade-out'); // Remove fade-out
            priceContainer.classList.add('fade-in'); // Apply fade-in effect
          }, 300); // Matches transition duration in CSS
        });

        swatch.addEventListener('mouseleave', function() {
          imageContainer.classList.add('fade-out'); // Start fade-out effect
          priceContainer.classList.add('fade-out'); // Start fade-out effect

          setTimeout(() => {
            imageContainer.innerHTML = ""; // Remove content after fade-out
            imageContainer.classList.remove('fade-in'); // Reset fade-in
            imageContainer.classList.remove('fade-out'); // Reset fade-out
            priceContainer.innerHTML = originalPrice; // Show the original price
            priceContainer.classList.remove('fade-in'); // Reset fade-in
            priceContainer.classList.remove('fade-out'); // Reset fade-out
          }, 300); // Matches transition duration
        });
      });
    });
  }

}

customElements.define("product-card", ProductCard);
